import { Link, useParams } from "react-router";
import { Alerta, Button, Card, Logo2M, Spinner, Stack, TextField } from "@/components";
import type { Usuario } from "@/lib/api";
import { MIN_PASSWORD } from "@/lib/usuarios";
import { useInvitacionTab } from "./useInvitacionTab";

export function InvitacionTab({ onIngreso }: { onIngreso: (u: Usuario) => void }) {
  const { token = "" } = useParams();
  const t = useInvitacionTab(token, onIngreso);
  return (
    <div className="grid min-h-dvh place-items-center px-4 py-10">
      <div className="w-full max-w-sm">
        <Stack espacio={6}>
          <div className="flex justify-center text-carbon">
            <Logo2M className="w-32" />
          </div>
          <Card>
            {t.cargando ? (
              <div className="grid place-items-center py-6 text-primario">
                <Spinner />
              </div>
            ) : t.errorCarga ? (
              <Stack espacio={4}>
                <p>{t.errorCarga}</p>
                <Link to="/login" className="font-medium text-primario underline">
                  Ir al ingreso
                </Link>
              </Stack>
            ) : (
              <form onSubmit={(e) => void t.enviar(e)} noValidate>
                <Stack espacio={4}>
                  <Stack espacio={1}>
                    <h1 className="text-pantalla font-light tracking-[-0.03em]">Hola, {t.nombre}</h1>
                    <p className="text-texto-suave">Elegí tu contraseña para entrar.</p>
                  </Stack>
                  <TextField etiqueta="Email" type="email" autoComplete="username" value={t.email} readOnly disabled />
                  <TextField
                    etiqueta="Contraseña nueva"
                    type="password"
                    autoComplete="new-password"
                    ayuda={`Mínimo ${MIN_PASSWORD} caracteres`}
                    value={t.password}
                    onChange={(e) => t.setPassword(e.target.value)}
                  />
                  <TextField
                    etiqueta="Repetí la contraseña"
                    type="password"
                    autoComplete="new-password"
                    value={t.repetida}
                    onChange={(e) => t.setRepetida(e.target.value)}
                  />
                  <Alerta texto={t.error} />
                  <Button type="submit" anchoCompleto cargando={t.guardando}>
                    Guardar y entrar
                  </Button>
                </Stack>
              </form>
            )}
          </Card>
        </Stack>
      </div>
    </div>
  );
}
